import 'slick-carousel';

var paths = window.location.href,
	basic = true,
    image = paths.substr(paths.indexOf("#") + 1);

    if($.isNumeric(image)) {
    	basic = false;
    }

function sb_project_slide_colors(slide) {

	var curSlide 	= slide,
		bgColor		= curSlide.attr('data-color'),
		bgImage 	= curSlide.attr('data-bg');

	$('body').css('background-color', bgColor);

	if(bgImage !== undefined) {
		$('body').css('background-image', 'url('+bgImage+')');
	} else {
		$('body').css('background-image', '');
	}

}

function sb_project_slider() {

	var imageSlide 	= $('.project-slides'),
		slide 		= 0;

		if(!basic) {
		   slide = image - 1;
		}

	imageSlide
	.on('init', function(event, slick){
		sb_project_slide_colors($(slick.$slides.get(slide)).find('.project-slide'));
	})
	.on('afterChange', function(event, slick, currentSlide, nextSlide){
		sb_project_slide_colors($(slick.$slides.get(currentSlide)).find('.project-slide'));

		//history.pushState("", document.title, window.location.pathname);
		if (history.replaceState) {
			history.pushState('', document.title, paths.substr(0, paths.indexOf("#"))+'#'+(currentSlide+1));
		}

	})
	.slick({

    	initialSlide: slide,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		speed: 0,
		fade: true,

        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">&larr;</button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button">&rarr;</button>',

	})
	.find(".slick-slide").on("click", function(){
		imageSlide.slick("slickNext");
	});



}

export default {
  finalize() {
  	sb_project_slider();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-post.js